import {v4 as uuidv4} from "uuid";
import {none, option} from "ts-option";
import BaseFormController from "../../../validation/BaseFormController";
import LeadStatus from "../../../model/lead/LeadStatus";
import {FormField, RequiredFormField} from "../../../validation/FormField";
import FormValidators from "../../../validation/FormValidators";
import FormValidation from "../../../validation/FormValidation";

export default class LeadStatusForm extends BaseFormController<LeadStatusForm> {

	public static createEmpty(): LeadStatusForm {
		return this.createLeadStatusForm({showPushNotification: option(false)});
	}

	public static createFromLeadStatus(leadStatus: LeadStatus): LeadStatusForm {
		return this.createLeadStatusForm({
			label: option(leadStatus.label),
			category: option(leadStatus.category),
			showPushNotification: option(leadStatus.showPushNotification)
		});
	}

	private static createLeadStatusForm({
		label = none,
		category = none,
		description = none,
		showPushNotification = none
	}) {
		const labelField = RequiredFormField.create<string>(label, "Label is required", [
			FormValidators.nonEmptyString("Label is required")
		]);
		return new LeadStatusForm(
			uuidv4(),
			labelField,
			RequiredFormField.create<string>(category, "Category is required", [
				FormValidators.nonEmptyString("Category is required")
			]),
			RequiredFormField.create<boolean>(showPushNotification, "Show push notification is required"),
			labelField
		);
	}

	constructor(public readonly formId: string,
		public readonly label: RequiredFormField<string>,
		public readonly category: RequiredFormField<string>,
		public readonly showPushNotification: RequiredFormField<boolean>,
		public readonly fieldWithFocus: FormField<string>) {
		super(fieldWithFocus, formId);
	}

	onValid(callback: (data: LeadStatus) => void) {
		const result = FormValidation.validateFields(
			[this.label, this.category, this.showPushNotification],
			() => {
				return new LeadStatus(
					uuidv4(),
					this.label.getValue(),
					this.category.getValue(),
					this.showPushNotification.getValue()
				)
			}
		);
		result.onSuccess((data) => {
			callback(data);
		});
	}

	copy({
		label = this.label,
		category = this.category,
		showPushNotification = this.showPushNotification
	}): LeadStatusForm {
		return new LeadStatusForm(this.formId,
			label,
			category,
			showPushNotification,
			this.fieldWithFocus);
	}

	fields(): Array<FormField<any>> {
		return [this.label, this.category];
	}
}
